// import { Heading,Center,Button } from "@chakra-ui/react"

function TipsTricksCard(props) {
    return (
        <div className="Tips-card">
            <h2>Tips Tricks Heading Goes Here</h2>
            <p>Tips Tricks Para: Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione sunt eligendi fugit doloribus, rem at nihil, a, aut quis optio recusandae laudantium corrupti repellendus officiis eius! Sint, laudantium minus vitae explicabo aut ex? Optio, quae.</p>
        </div>
    )
}

export default TipsTricksCard
